import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';

import style from '../otherAdditionalService/otherAdditionalService.module.css';
import commonStyles from '../../../common/common.module.css';

const TEXT_FIELD_PADDINGS: string = '8px 12px';
const styles = (theme: any) => ({

  growField: {
    flexGrow: 1,
    marginRight: '20px'
  }
});

interface AdjustServiceProps {
  classes: any;
  reason: string;
  total: string;
  additionalInformation: string;
  handleChange: (event: any, propertyName: string) => void;
  error: boolean;
  
};

const adjustService = (props: AdjustServiceProps) => {
  return (
    <FormControl fullWidth={ true }>
      <div className={ style.flexContainer }>
        <div className={ commonStyles.inputLabelWrapper } >
          <label className={ commonStyles.inputLabel }> Adjust Service Reason <span className={ style.asterisk }>*</span> </label>
          <TextField
            error={ props.error && !props.reason }
            label=""
            value={ props.reason }
            variant="outlined"
            onChange={ (event) => props.handleChange(event, 'adjustServiceReason') }
            className={props.classes.growField}
            inputProps={{ style: { padding: TEXT_FIELD_PADDINGS } }}
            InputProps={{ classes: { notchedOutline: props.classes.overrideBorder } }}
            InputLabelProps={{ shrink: true }}
          />
        </div>

        <div className={ commonStyles.inputLabelWrapper } >
          <label className={ commonStyles.inputLabel }> Total Cost <span className={ style.asterisk }>*</span></label>
          <TextField
            error={ props.error && !props.total || (props.total.length>1 && isNaN(Number(props.total))) }
            label=""
            value={ props.total }
            variant="outlined"
            onChange={ (event) => props.handleChange(event, 'adjustServiceTotal') }
            inputProps={{ style: { padding: TEXT_FIELD_PADDINGS } }}
            InputProps={{ classes: { notchedOutline: props.classes.overrideBorder } }}
            InputLabelProps={{ shrink: true }}
          />
        </div>    
      </div>
      
      <div className= { ` ${ style.addInfoWrapper } ${ commonStyles.inputLabelWrapper }` }>
        <label className={ commonStyles.inputLabel }> Additional information to GHA </label>
        <TextField
          fullWidth={ true }
          id="outlined-disabled"
          label=""
          variant="outlined"
          onChange={ (event) => props.handleChange(event, 'additionalInformation') }
          value={ props.additionalInformation }
          inputProps={{ style: { padding: TEXT_FIELD_PADDINGS } }}
          InputProps={{ classes: { notchedOutline: props.classes.overrideBorder } }}
          InputLabelProps={{ shrink: true }}
        />
      </div>
    </FormControl>
  );
}

export default withStyles(styles)(adjustService);